module.exports = __webpack_public_path__ + "static/media/Cog.9ea8545c.svg";